import vmClient from 'app/services/vmClient';
import { UserProfile, IUserProfile } from 'app/constants/schemas/UserProfile';
import { Room, IRoom } from 'app/constants/schemas/rtc/Room';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

export interface IBotBooking extends IEntity {
  attributes: {
    id: EntityStringId;
  };
  associations: {
    owner: IUserProfile;
    rtcRoom: IRoom | null;
  };
}

export type BotBooking = Entity<IBotBooking>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BotBooking: IEntityType<IBotBooking> = vmClient.defineClass({
  typeName: 'BotBooking',
  version:  1,
  persisted: true,

  associations: {
    owner:  {
      type:   UserProfile,
      shared: true,
      notNull: true,
    },
    rtcRoom: { type: Room },
  },
});
